<script>
  import {createEventDispatcher} from 'svelte';

  const dispatch = createEventDispatcher();

  export let project;
  export let withPlaylistIcon = false;
</script>

{#if project}
  <header>
    <i class="nes-icon trophy is-large"></i>
    <h2>{project.name}</h2>

    {#if withPlaylistIcon}
      <img src="/assets/images/playlist.png" on:click={() => dispatch('playlist')} title="Download playlist" />
    {/if}
  </header>
{/if}

<style>
    header {
        display: flex;
        align-items: center;
        width: 100%;
        margin-bottom: 2rem;
    }

    header h2 {
        font-size: 32px;
        margin-left: 1.5rem;
        margin-bottom: 0;
    }

    header img {
        width: 24px;
        height: 24px;
        align-self: flex-start;
        cursor: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAzElEQVRYR+2X0Q6AIAhF5f8/2jYXZkwEjNSVvVUjDpcrGgT7FUkI2D9xRfQETwNIiWO85wfINfQUEyxBG2ArsLwC0jioGt5zFcwF4OYDPi/mBYKm4t0U8ATgRm3ThFoAqkhNgWkA0jJLvaOVSs7j3qMnSgXWBMiWPXe94QqMBMBc1VZIvaTu5u5pQewq0EqNZvIEMCmxAawK0DNkay9QmfFNAJUXfgGgUkLaE7j/h8fnASkxHTz0DGIBMCnBeeM7AArpUd3mz2x3C7wADglA8BcWMZhZAAAAAElFTkSuQmCC) 14 0, pointer;
        transition: transform 300ms;
    }
    header img:hover {
        transform: scale(1.5);
    }

    @media screen and (max-width: 767px) {
        header {
            justify-content: center;
        }
    }
</style>